import { MobileCalendarTable, WebCalendarTable } from "components";
import React from "react";
import { View } from "react-native";
import { CalendarCollection, UserCollection } from "types";
import { IsWeb } from "utils";

/**
 * ダッシュボード用のカレンダーをWeb・Mobileで切り替えます
 * @param param0
 * @returns
 */
export const CalendarTable = ({
  tableList,
  onEditClick,
  UserCollection,
}: {
  tableList: CalendarCollection[] | null;
  onEditClick: (id: string) => void;
  UserCollection: UserCollection[];
}) => {
  return (
    <>
      {tableList === null ? (
        <View></View>
      ) : IsWeb() ? (
        <WebCalendarTable tableList={tableList} />
      ) : (
        <MobileCalendarTable onEditClick={onEditClick} tableList={tableList} />
      )}
    </>
  );
};
